import { RequestModel } from "model";

import { useSchools } from "~components/FormFields";
import RequestForm from "~components/RequestForm/RequestForm";
import { useURLSearchParams } from "~utils";

export function RequestFormParams() {
  const urlParam = useURLSearchParams();

  const schools = useSchools();

  if (!schools) {
    return <div>Loading...</div>;
  }

  const schoolParam = urlParam.get("school");
  const timeParams = urlParam.get("intervals");
  const teacherParam = urlParam.get("teacher");

  const mySchool = schools.find((school) => school.id === schoolParam);

  const times = JSON.parse(timeParams || "[]");

  const usableTimes = times.map((ele: Array<number>, idx: number) => {
    return {
      // db/id doesn't matter.
      "db/id": idx,
      "interval/start": new Date(ele[0]).toISOString(),
      "interval/start-offset": 480,
      "interval/end": new Date(ele[1]).toISOString(),
      "interval/end-offset": 480,
    };
  });

  const newRequest = new RequestModel({
    "sub-req/school": mySchool?.raw,
    "sub-req/time": usableTimes,
    "sub-req/teacher": teacherParam || "",
  });

  return (
    <div className="mw-800">
      <h1>Request Sub AMS</h1>
      <RequestForm schools={schools} request={newRequest}></RequestForm>
    </div>
  );
}
